import { render, staticRenderFns } from "./applications.vue?vue&type=template&id=70431f87"
import script from "./applications.vue?vue&type=script&lang=js"
export * from "./applications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports